/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Clock': {
    width: 16,
    height: 16,
    viewBox: '0 0 28 28',
    data: '<defs><path pid="0" id="svgicon_Clock_a" d="M8.7 0a8.7 8.7 0 110 17.4A8.7 8.7 0 018.7 0zm0 1.7a7 7 0 107 7 7.02 7.02 0 00-7-7zM8.825 4c.455 0 .825.339.825.757v4.021l2.12 1.925a.752.752 0 010 1.08.866.866 0 01-.588.217.866.866 0 01-.59-.216L8.236 9.622A.807.807 0 018 9.08V4.757C8 4.339 8.37 4 8.825 4z"/></defs><use transform="translate(5 5)" xlink:href="#svgicon_Clock_a"/>'
  }
})
